import React from 'react';
import { Provider } from "react-redux";
import './App.css';
import MyNavbar from './components/MyNavbar';
import Home from './pages/Home';
import Favorites from './pages/Favorites';
import Detail from './pages/Detail';
import SearchResult from './pages/SearchResult';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import store from './store';

function App() {
  return (
    <Provider store={ store }>
      <Router>
        <MyNavbar/>

        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
          <Route path="/favorites"><Favorites/></Route>
          <Route path="/detail/:id"><Detail/></Route>
          <Route path="/search"><SearchResult/></Route>
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
